import { WeightunitPipe } from './weightunit.pipe';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedFacade } from './+state/shared.facade';
import { ConfiguratorFacade } from './+state/configurator.facade';
import { IssuesService } from './issues/issues.service';
import { IssuesService as AbstractIssuesService, ModalService } from '@icc/shared/helpers';
import { CurrencyPipe, ExchangePipe } from '@icc/shared/currency';
import { ConfiguratorModalService } from './steps/modal.service';
import { DrawService } from '@icc/configurator/draw';
import { IccDrawModule } from '@icc/draw';
import { DrawResizeDirective } from './draw-resize/draw-resize.directive';
import { UnitmmPipe } from './unitmm.pipe';
import { UnitmPipe } from './unitm.pipe';
import { Unitm2Pipe } from './unitm2.pipe';
import { Unit2dPipe } from './unit2d.pipe';
import { FormatUnitPipe } from './format-unit.pipe';
import { HotkeyModule } from 'angular2-hotkeys';
import { CommonModule } from '@angular/common';
import { DrawRefreshDirective } from './draw-resize/draw-refresh.directive';
import { DigitsOnlyDirective } from './directives/digits-only.directive';
import { LetterPipe } from './letter.pipe';
import { SharedUnitPipeModule } from './shared-unit-pipe.module';
import { MultiplierPipe } from './multiplier.pipe';
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        IccDrawModule,
        HotkeyModule,
        SharedUnitPipeModule,
    ],
    exports: [
        TranslateModule,
        IccDrawModule,
        DrawResizeDirective,
        DrawRefreshDirective,
        CurrencyPipe,
        ExchangePipe,
        MultiplierPipe,
        UnitmmPipe,
        UnitmPipe,
        Unitm2Pipe,
        Unit2dPipe,
        FormatUnitPipe,
        WeightunitPipe,
        DigitsOnlyDirective,
        LetterPipe,
        SharedUnitPipeModule,
    ],
    declarations: [
        DrawResizeDirective,
        DrawRefreshDirective,
        CurrencyPipe,
        ExchangePipe,
        MultiplierPipe,
        UnitmmPipe,
        UnitmPipe,
        Unitm2Pipe,
        Unit2dPipe,
        FormatUnitPipe,
        WeightunitPipe,
        DigitsOnlyDirective,
        LetterPipe,
    ],
    providers: [
        DrawService,
        SharedFacade,
        ConfiguratorFacade,
        IssuesService,
        CurrencyPipe,
        { provide: AbstractIssuesService, useExisting: IssuesService },
        { provide: ModalService, useClass: ConfiguratorModalService },
    ],
})
export class SharedModule {}
